<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <form *ngIf="!!user" #userForm="ngForm" autocomplete="off">
    <div class="flex flex-col gap-3">

      <!-- Row 1: First Name + Last Name -->
      <div class="grid grid-cols-12 gap-3">
        <uni-field label="First Name" class="col-span-6">
          <input pInputText required minlength="2" placeholder="First Name" name="firstname"
            [(ngModel)]="user.FirstName" #firstname="ngModel" />
        </uni-field>
        <uni-field label="Last Name" class="col-span-6">
          <input pInputText required minlength="2" placeholder="Last Name" name="lastname"
            [(ngModel)]="user.LastName" #lastname="ngModel" />
        </uni-field>
      </div>

      <!-- Row 2: Initials + User Name -->
      <div class="grid grid-cols-12 gap-3">
        <uni-field label="Initials" class="col-span-6">
          <input pInputText required minlength="2" maxlength="4" placeholder="Initials"
            name="initials" [(ngModel)]="user.Initials" #initials="ngModel" [validatorFn]="validateInitials"
            (ngModelChange)="user.Initials = $event.toUpperCase()" [disabled]="!canEditInitials()" />
        </uni-field>
        <uni-field label="User Name" class="col-span-6">
          <input pInputText required type="email" email placeholder="Username (Email)" name="username"
            [(ngModel)]="user.User.UserName" autocomplete="new-text" [validatorFn]="validateEmail" />
        </uni-field>
      </div>

      <!-- Row 3: Cell Number + Locked Out -->
      <div class="grid grid-cols-12 gap-3">
        <uni-field label="Cell Number" class="col-span-6">
          <input pInputText placeholder="Cell Number (for SMS)" name="phoneNumber"
            [(ngModel)]="user.User.PhoneNumber" />
        </uni-field>
        <div class="col-span-6 flex items-center gap-2 mt-6">
          <p-checkbox inputId="IsLockedOut" [disabled]="!isUserAdmin" [binary]="true"
            [(ngModel)]="user.IsLockedOut" name="lockedOut"></p-checkbox>
          <label for="IsLockedOut">Locked Out</label>
        </div>
      </div>

      <!-- Row 4: Password + Confirm Password -->
      <div class="grid grid-cols-12 gap-3">
        <uni-field label="Password" class="col-span-6">
          <input pInputText [required]="user.id=='new'" type="password" placeholder="Password" name="password"
            class="p-invalid" [(ngModel)]="user.Password" #password="ngModel" [pattern]="pwRegex"
            autocomplete="new-password" />
          <small class="uni-error" *ngIf="hasError(password)">Min 8 chars: upper, lower, number, special</small>
        </uni-field>
        <uni-field label="Confirm Password" class="col-span-6">
          <input pInputText [required]="user.id=='new'" type="password" placeholder="Confirm Password"
            name="confirmPassword" [(ngModel)]="confirmPassword" #confirm="ngModel" [validatorFn]="validateConfirm" />
        </uni-field>
      </div>

      <!-- Roles Section -->
      <div class="border-t pt-3 mt-1">
        <div class="font-semibold text-sm mb-2 uppercase tracking-wide">Roles</div>
        <div class="grid grid-cols-3 gap-x-4 gap-y-2">
          <div *ngFor="let role of userRoles" class="flex items-center gap-2">
            <p-checkbox [disabled]="(!isUserAdmin) || user.IsLockedOut" [(ngModel)]="role.isSelected" [binary]="true"
              [name]="role.name" [inputId]="role.name">
            </p-checkbox>
            <label [for]="role.name">{{UtilFns.splitCamelCaseToString(role.name)}}</label>
          </div>
        </div>
      </div>

    </div>
  </form>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button pButton type="button" class="p-button-raised" [disabled]="!canSave()" (click)="save()">
      Save
    </button>
    <button pButton type="button" class="p-button-raised" [disabled]="!user" (click)="close()">
      Cancel
    </button>
  </div>
</ng-template>
